import React, { createContext, useContext } from "react";
import { Position } from "../../../../../domain/models/position-model";
import { StoreItem } from "../../../../../domain/models/storage-item";
import { AuditPositionResult } from "../../../../../domain/usecases/audit-position";

type Context = {
  position: Position | null;
  setPosition: React.Dispatch<React.SetStateAction<Position | null>>;
  list: StoreItem[] | null;
  setList: React.Dispatch<React.SetStateAction<StoreItem[] | null>>;
  result: AuditPositionResult | null;
  setResult: React.Dispatch<React.SetStateAction<AuditPositionResult | null>>;
};

export const AuditContext = createContext<Context>({
  position: null,
  setPosition: () => {},
  list: null,
  setList: () => {},
  result: null,
  setResult: () => {},
});

export const useAuditContext = () => {
  const context = useContext(AuditContext);
  if (!context) {
    throw new Error("useAuditContext must be used within a AuditProvider");
  }
  return context;
};
